import React from 'react';
import DonorSidebar from '../../layouts/donor/DonorSidebar';
import DonorNavbar from '../../layouts/donor/DonorNavbar';
import '../../assets/css/layout/donor/DonorLayout.css';

const DonorLayout = ({children}) => {
  return (
    <div className="dnl-donor-layout-wrapper">
      {/* Sidebar - Fixed position */}
      <DonorSidebar />
      <div className="dnl-donor-main">
      {/* Navbar - Fixed position */}
      <DonorNavbar />
      
      {/* Main Content Area */}
     
        <div className="dnl-donor-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DonorLayout;
